module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.modalCookie && _vm.display) ? _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [(_vm.modal) ? _c('div', {
    staticClass: "modal__overlay"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modal) ? _c('div', {
    staticClass: "modal modal__welcome"
  }, [_c('span', {
    staticClass: "modal__title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "modal__content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.button))])]) : _vm._e()])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-effb8c84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 146
// module chunks = 2